import { isFileKeyPath, isShareFileKeyPath } from '@common/utils/fileStorage';
import api from '@common/configs/api';

const urlCache = new Map<string, { url: string; expiresAt: number }>();
const CACHE_TTL_MS = 6 * 24 * 60 * 60 * 1000;

async function fetchSignedUrl(
  keyPath: string,
  service: 'files' | 'sharefiles'
): Promise<string> {
  const cacheKey = `${service}:${keyPath}`;
  const cached = urlCache.get(cacheKey);
  if (cached && cached.expiresAt > Date.now()) {
    return cached.url;
  }

  const { data } = await api({
    method: 'get',
    url: service,
    params: { pathObject: keyPath },
  });

  urlCache.set(cacheKey, {
    url: data.url,
    expiresAt: Date.now() + CACHE_TTL_MS,
  });

  return data.url;
}

export async function resolveFileUrl(
  value: string | null | undefined
): Promise<string | null> {
  if (!value) return null;
  if (!isFileKeyPath(value)) return value;

  const service = isShareFileKeyPath(value) ? 'sharefiles' : 'files';
  return fetchSignedUrl(value, service);
}

export async function resolveFileFieldValue(
  value: string | { url?: string } | null | undefined
): Promise<string | null> {
  if (!value) return null;
  if (typeof value === 'string') return resolveFileUrl(value);
  if (value.url) return resolveFileUrl(value.url);
  return null;
}
